import api from './api'
import type { RestaurantTable } from '@/types'

export const tableService = {
  // ========== Tables CRUD ==========
  async getTables(restaurantId: string, activeOnly = false): Promise<RestaurantTable[]> {
    const response = await api.get<RestaurantTable[]>(
      `/api/tables?restaurantId=${restaurantId}&activeOnly=${activeOnly}`
    )
    return response.data
  },

  async getTableById(tableId: string): Promise<RestaurantTable> {
    const response = await api.get<RestaurantTable>(`/api/tables/${tableId}`)
    return response.data
  },

  async createTable(
    restaurantId: string,
    data: Omit<RestaurantTable, 'id' | 'restaurantId' | 'qrCodeData' | 'qrCodeUrl' | 'createdAt' | 'updatedAt'>
  ): Promise<RestaurantTable> {
    const response = await api.post<RestaurantTable>(`/api/tables?restaurantId=${restaurantId}`, data)
    return response.data
  },

  async updateTable(
    tableId: string,
    data: Partial<Omit<RestaurantTable, 'id' | 'restaurantId' | 'qrCodeData' | 'qrCodeUrl' | 'createdAt' | 'updatedAt'>>
  ): Promise<RestaurantTable> {
    const response = await api.put<RestaurantTable>(`/api/tables/${tableId}`, data)
    return response.data
  },

  async toggleTableStatus(tableId: string): Promise<RestaurantTable> {
    const response = await api.patch<RestaurantTable>(`/api/tables/${tableId}/status`)
    return response.data
  },

  async regenerateQRCode(tableId: string): Promise<RestaurantTable> {
    const response = await api.post<RestaurantTable>(`/api/tables/${tableId}/regenerate-qr`)
    return response.data
  },

  async deleteTable(tableId: string): Promise<void> {
    await api.delete(`/api/tables/${tableId}`)
  },

  async getTableCount(restaurantId: string): Promise<number> {
    const response = await api.get<number>(`/api/tables/count?restaurantId=${restaurantId}`)
    return response.data
  },
}
